import { SCREENS } from 'commons/utils/permissions'
import { ROUTES } from 'constants/urls'

import type { MenuSection } from '../MenuSidebar/MenuSidebar'

export const SIDEBAR_IDS = {
  APPROVAL_RANGES: 'backoffice-ranges',
  APPROVALS: 'approvals',
  BACKOFFICE: 'backoffice',
  CREATE_ORDER: 'orders',
  EDI_MANAGEMENT: 'edi-management',
  EXPORT_ORDER: 'orders-international',
  EXTRA_VOLUME: 'extra-volume',
  FAIR_SHARE: 'fairshare',
  FRANCHISES_ORDER: 'franchises',
  HOME_PAGE: 'home',
  INTERNATIONAL_SAMPLE: 'samples-international',
  KEY_ACCOUNTS: 'backoffice-key-accounts',
  LEAD_TIMES: 'backoffice-lead-times',
  MANAGE_ORDER: 'manage-order',
  NATIONAL_SAMPLE: 'samples-national',
  ND: 'negotiations',
  RECOMMENDATION: 'recommendations',
  SALES: 'sales',
  SALES_CALENDAR: 'sales-calendar',
  SAMPLE_ORDER: 'samples',
  SINGLE_ORDER: 'orders-national',
  STOCK_REPORT: 'stock-report',
}

export const menuObj: MenuSection[] = [
  {
    menuLists: [
      {
        itemId: SIDEBAR_IDS.HOME_PAGE,
        leftIcon: 'house',
        permission: SCREENS.HOME,
        titleKey: 'common.navigation.homePage',
        to: ROUTES.app.base,
      },
    ],
  },
  {
    menuLists: [
      {
        itemId: SIDEBAR_IDS.CREATE_ORDER,
        leftIcon: 'package',
        menuItems: [
          {
            itemId: SIDEBAR_IDS.SINGLE_ORDER,
            permission: SCREENS.ORDER,
            titleKey: 'common.navigation.singleOrder',
            to: `${ROUTES.orders.base}${ROUTES.orders.children.new.base}`,
          },
          {
            itemId: SIDEBAR_IDS.EXPORT_ORDER,
            permission: SCREENS.INTERNATIONAL_EDI,
            titleKey: 'common.navigation.exportOrder',
            to: `${ROUTES.orders.base}${ROUTES.orders.children.batchOrders.base}${ROUTES.orders.children.batchOrders.children.international.base}`,
          },
          {
            itemId: SIDEBAR_IDS.FRANCHISES_ORDER,
            permission: SCREENS.FRANCHISES_BATCH,
            titleKey: 'common.navigation.franchisesOrder',
            to: `${ROUTES.orders.base}${ROUTES.orders.children.batchOrders.base}${ROUTES.orders.children.batchOrders.children.franchises.base}`,
          },
          {
            itemId: SIDEBAR_IDS.SAMPLE_ORDER,
            menuItems: [
              {
                itemId: SIDEBAR_IDS.NATIONAL_SAMPLE,
                permission: SCREENS.NATIONAL_SAMPLE,
                titleKey: 'common.navigation.nationalSample',
                to: `${ROUTES.orders.base}${ROUTES.orders.children.nationalSampleOrder.base}`,
              },
              {
                itemId: SIDEBAR_IDS.INTERNATIONAL_SAMPLE,
                permission: SCREENS.INTERNATIONAL_SAMPLE,
                titleKey: 'common.navigation.internationalSample',
                to: `${ROUTES.orders.base}${ROUTES.orders.children.internationalSampleOrder.base}`,
              },
            ],
            titleKey: 'common.navigation.sampleOrder',
          },
        ],
        titleKey: 'common.navigation.createOrder',
      },
      {
        itemId: SIDEBAR_IDS.MANAGE_ORDER,
        leftIcon: 'file-spreadsheet',
        permission: SCREENS.MANAGE,
        titleKey: 'common.navigation.manageOrder',
        to: ROUTES.manage.base,
      },
      {
        itemId: SIDEBAR_IDS.RECOMMENDATION,
        leftIcon: 'star',
        permission: SCREENS.RECOMMENDATION,
        titleKey: 'common.navigation.recommendation',
        to: '',
      },
      {
        itemId: SIDEBAR_IDS.STOCK_REPORT,
        leftIcon: 'feet',
        permission: SCREENS.HOME,
        titleKey: 'common.navigation.stockReport',
        to: ROUTES.stock_report.base,
      },
    ],
    titleKey: 'common.navigation.sales',
  },
  {
    menuLists: [
      {
        itemId: SIDEBAR_IDS.APPROVALS,
        leftIcon: 'circle-check',
        menuItems: [
          {
            itemId: SIDEBAR_IDS.ND,
            permission: SCREENS.ND_MANAGE,
            titleKey: 'common.navigation.nd',
            to: ROUTES.nd.base,
          },
          {
            itemId: SIDEBAR_IDS.EXTRA_VOLUME,
            permission: SCREENS.EXTRA_VOLUME,
            titleKey: 'common.navigation.extraVolume',
            to: ROUTES.extra_volume.base,
          },
          {
            itemId: SIDEBAR_IDS.APPROVAL_RANGES,
            permission: SCREENS.BACKOFFICE_RANGE,
            titleKey: 'common.navigation.approvalRanges',
            to: `${ROUTES.backoffice.base}${ROUTES.backoffice.children.ranges.base}`,
          },
        ],
        titleKey: 'common.navigation.approvals',
      },
      {
        itemId: SIDEBAR_IDS.LEAD_TIMES,
        leftIcon: 'calendar-clock',
        permission: SCREENS.TECHNICAL_CONSULTATION,
        titleKey: 'common.navigation.leadTimes',
        to: `${ROUTES.backoffice.base}${ROUTES.backoffice.children.lead_times.base}`,
      },
      {
        itemId: SIDEBAR_IDS.KEY_ACCOUNTS,
        leftIcon: 'user-star',
        permission: SCREENS.TECHNICAL_CONSULTATION,
        titleKey: 'common.navigation.keyAccounts',
        to: `${ROUTES.backoffice.base}${ROUTES.backoffice.children.key_accounts.base}`,
      },
      {
        itemId: SIDEBAR_IDS.FAIR_SHARE,
        leftIcon: 'circle-percent',
        permission: SCREENS.FAIR_SHARE,
        titleKey: 'common.navigation.fairShare',
        to: ROUTES.fairShare.base,
      },
      {
        itemId: SIDEBAR_IDS.SALES_CALENDAR,
        leftIcon: 'calendar-plus',
        permission: SCREENS.SALES_CALENDAR,
        titleKey: 'common.navigation.salesCalendar',
        to: ROUTES.salesCalendar.base,
      },
      {
        itemId: SIDEBAR_IDS.EDI_MANAGEMENT,
        leftIcon: 'refresh-cw',
        permission: SCREENS.EDI_MANAGEMENT,
        titleKey: 'common.navigation.ediManagement',
        to: ROUTES.ediManagement.base,
      },
    ],
    titleKey: 'common.navigation.backoffice',
  },
]
